import dayjs from 'dayjs';

import { CustomTableFilterDefinition } from '@/components/table/components/formBuilder/model/CustomTableFilterDefinition.model.ts';

type Normalized = Normalized[] | boolean | number | string | null;

const normalize = (value: unknown): Normalized => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.format('YYYY-MM-DD') : null;
  }
  if (Array.isArray(value)) {
    const items = value
      .map(normalize)
      .filter(item => item !== null)
      .map(item => JSON.stringify(item))
      .sort();
    return items.length === 0 ? null : items;
  }
  if (typeof value === 'object') {
    if ('value' in value) {
      return normalize(value.value);
    }
    if ('dictionaryId' in value) {
      return normalize(value.dictionaryId);
    }
    return JSON.stringify(value);
  }
  if (typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string') {
    return value;
  }
  return null;
};

export const countActiveFilters = <MODEL extends object>(
  filters: CustomTableFilterDefinition<MODEL>[],
  values: Partial<MODEL>,
): number => filters.filter(filter => normalize(values[filter.name]) !== null).length;
